import { Loader, Select } from "@mantine/core"
import React from "react"
import { useActions, useAppState } from "src/state"
import { Area_Status_Enum } from "src/state/gql/_types"
import { GenericFieldProps } from "src/utils/forms"
import { capitalizeWords } from "src/utils/string"

export const OperationsAdminAreaSelect: React.FC<GenericFieldProps> = ({ id, name, label, onChange, onBlur, value, error, required, description, disabled, classNames }) => {

    const { itemsList, loading } = useAppState(state => state.areas)
    const { tenant_id: currentTenantId } = useAppState(state => state.auth)
    const getItems = useActions().areas.getItems

    React.useEffect(() => {

        let controller: AbortController | null = new AbortController();

        const loadItems = async () => {

            if (controller) {
                try {
                    await getItems({
                        where: {
                            venue_id: {
                                _eq: currentTenantId
                            },
                            status: {
                                _eq: Area_Status_Enum.Active
                            }
                        }
                    })
                    controller = null;
                } catch (e: any) {
                    if (e.name !== 'AbortError') {
                        console.error(e)
                    }
                }
            }

        }

        loadItems()

        return () => controller?.abort()

    }, [getItems])

    if (!!!itemsList.length) error = 'No Active Areas'

    return (
        <Select
            label={label}
            id={id}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            error={error}
            required={required}
            disabled={disabled}
            description={description}
            rightSection={loading ? <Loader size="xs" /> : null}
            placeholder="Select Venue Area..."
            searchable
            clearable
            data={
                itemsList.map(i => ({
                    label: capitalizeWords(`${i.name}`),
                    value: i.id
                }))
            }
            autoComplete="off"
            classNames={classNames}
        />
    )

}